// extracted by mini-css-extract-plugin
export default {"icon":"TeamSelected_icon__Lb5SP","linkIcon":"TeamSelected_linkIcon__aAb0j","contact-text":"TeamSelected_contact-text__egyYa"};